import { EntityBase } from "./entity-base.model";
export class Province extends EntityBase {
  public Code: number;
  public Title: string;
}  
